import UserConvert from "./UserConvert";

const MaxCmdLength = 64;//数组统一大小
const CommandLength = 64;//实际命令长度
const BOOT_SIZE = 0x2000;//boot大小
const CmdDataLength = 10;
const ResetVirtualTime = 2000;    //假设复位时为2s
const VirtualPacketInterval = 10;      //假设发一包数据需要10ms

var FILE_TYPE = {
  Keyboard : 0xd1,//键盘
  Mouse : 0xd2,//鼠标
  Dongle : 0xd3,//2.4G usb接收器
};

var Usb_Packet = {
  Usb_NextPacket : 0xC0,//下一包
  Usb_LastPacket : 0xC1,//最后一包
};

var Usb_Cmd = {
  Cmd_PrepareDownLoad : 0xB0,//通知鼠标准备下载，鼠标此时会擦除flash
  Cmd_DownLoadFile : 0xB1,//下载固件数据
  Cmd_DeviceState : 0x5B,//返回正在处理的状态
  Cmd_DeviceError : 0x5A,//返回错误信息
};

var UpgradeStateParam = {
  DeviceState_Earse_Backup : 0x01,//擦除备份区
  DeviceState_Earse_Main : 0x02,//擦除运行区
  DeviceState_CheckOK : 0x05,//校验运行区CRC OK
  DeviceState_PrepareDownLoad : 0x10,//预下载
  DeviceState_Device_To_Boot_Mode : 0x11,//等待设备从正常模式进入boot模式
  DeviceState_Success : 0x88,//升级完成
};

//以下是升级过程中回调的信息(共8字节，第0字节固定为0x07),一般用户只需处理以下3种情况即可：
// (1)0x07,DownLoadFile,percent,0x00,0x00,0x00,0x00,0x00 //表示升级百分比(0~100)
// (2)0x07,UpgradeResult,Success,0x00,0x00,0x00,0x00,0x00 //表示升级成功
// (3)0x07,UpgradeResult,TimeOutError,0x00,0x00,0x00,0x00,0x00 //表示升级失败
// var UpgradeState = {
//     DownLoadFile : 1,//正在下载文件，后面一个字节表示下载的进度（0~100）
//     UpgradeResult : 2,    //升级结果,后面一个字节是表示原因，详见UpgradeResultParam
//     UpgradeState : 3,         //升级状态，即当前升级到哪一步，用户无须关心此消息
// };

var UpgradeState = 
{
  Standby : 0,//待机
  Success : 1,//升级成功
  Upgrading : 2,//升级中
  UpgradeNext : 3,//升级下一个设备

  UserCancel : 0x10,//用户取消连接
  UserCancelNext : 0x11,//用户取消第二个设计设备连接
  //>0x80 代表升级失败错误
  Fail : 0x81,
  TimeOutError : 0x82,//操作超时 
  RepeatCountMax : 0x83,//发送数据
  DeviceError : 0x84,//设备出错
  DeviceInvalid : 0x85,//设备无效
};

var UsbUpgradeCommand = {
    isEnd : false,
    isValid : true,

    buffer : new Uint8Array(MaxCmdLength),
}

var BootModeReport = {
    cmdlength : 0x11,//命令长度,从reportId开始算起
    feature : 0,//0 - output  1-feature

    command : new Uint8Array(CmdDataLength - 2)
}

var UpgradeFileHeader = {
    headCRC : 0,//文件头crc
    headLength : 0,//文件头长度
    fwLength : 0, //要下载的程序(firmware)长度,起始位置固定为BOOT_SIZE。
    nextFileAddress : 0,//下一个文件的起始地址，用于多个芯片程序并在一个bin文档中，为0则表示没有

    version : 0,
    DeciveType : 0,
    Cid : 0,
    Mid : 0,
   
    fileId : new Uint8Array(MaxCmdLength),//文件标识，固定为ComUpgradeFile    
    icName: new Uint8Array(MaxCmdLength),//ic的名字   
    bootInputEndPoint: new Uint8Array(MaxCmdLength),//vid_3554&pid_f502&mi_01&col05   
    bootOutputEndPoint: new Uint8Array(MaxCmdLength),//vid_3554&pid_f502&mi_01&col05    
    normalInputEndPoint: new Uint8Array(MaxCmdLength),//vid_3554&pid_f502&mi_01&col05    
    normalOutputEndPoint: new Uint8Array(MaxCmdLength),//vid_3554&pid_f502&mi_01&col05    
    resetToUpdateModeCmd: new Uint8Array(MaxCmdLength),//正常模式复位进入下载模式命令,第一个字节表示长度    
    prepareDownLoadCmd: new Uint8Array(MaxCmdLength),//不同的ic，第一条预下载命令有可能不一样，所以单独存储，第一个字节表示长度    
    dataDownLoadCmd: new Uint8Array(MaxCmdLength),//数据下载包,第一个字节表示长度,第二个字节表示report id,其他字节无用     
    senserName: new Uint8Array(MaxCmdLength),//鼠标所用的sensor   
    productName: new Uint8Array(MaxCmdLength),//产品名称
}

var errorTimeout = 0;
var reSendCount = 0;
var reSendIndex = 0;

var mainFileHeader;
var mainUpgradeData;
var slaveFileHeader;
var slaveUpgradeData;
var fileHeader;

var currentPacketCount = 0;//当前已经发了多少包
var totalPacketCount = 0;//整个升级过程总包数，两颗芯片时，为两都总和，也可包括复位时虚拟的数据包（为了让复位时百分比也在增加）

var writeQueue = [];

var device;
var upgardeNormalDevice = true;
var currentDeviceIsNormal = false;
var upgradeState ={
  state:UpgradeState.Standby,
  percent:0
};
var receivedData = [];
var receivedFlag = false;
var hasNextDevice = false;
var upgradeNext = false;

//查询是否在线定时器
var upgradeTimerID;
var isTimeOut = false;

var normalReportId = 8;
var bootReportId = 6;

var normalFilter = {
  vendorId:0,
  productId:0
}

var bootFilter = {
  vendorId:0,
  productId:0
}

var filters = [];
var reportIds = [];

var mcuType = 0;//0->Compx 1->NRF54H20 

async function Request_Device() {
  const devices = await navigator.hid.requestDevice({filters});
  if(devices.length == 0) {
    if(upgradeNext)
      upgradeState.state = UpgradeState.UserCancelNext;
    else {
      upgardeNormalDevice = false;//用户取消后需要再次弹窗选择buoot设备
      upgradeState.state = UpgradeState.UserCancel;
    }
    return false;    
  }

  device = null;

  var index = 0;
  for(index = 0;index < reportIds.length;index++) {
    if(devices[0].vendorId === filters[index].vendorId &&
      devices[0].productId === filters[index].productId) {
        break;
      }
  }

  var valid = false;
  for(let temp of devices) {
    //判断连接设备的端口是否符合要求
    for(let i = 0;i < temp.collections.length;i++) {
      if(mcuType == 1) {
        if (temp.collections[i].featureReports.length === 1) {
          if(ReportId == temp.collections[i].featureReports[0].reportId) { 
            valid = true;                            
          }
        }
      }
      else {
        if (temp.collections[i].featureReports.length === 1) {
          if(reportIds[index] == temp.collections[i].featureReports[0].reportId) { 
            valid = true;                            
          }
        }
        else if((temp.collections[i].inputReports.length === 1 && 
          temp.collections[i].outputReports.length === 1)) {
          if(reportIds[index] == temp.collections[i].outputReports[0].reportId) {        
            valid = true;                      
          }
        }
      }


      if(valid) {
        break;  
      }
    }  
    
    if(valid) {
      device = temp;

      if(!device.opened) {
        await device.open();
      } 
    
      if(mcuType == 0) 
        read_HID_Buffer();
      Device_Disconnect();
      break;  
    }
  }
  if(valid) {
    upgardeNormalDevice = true;

    if(mcuType == 0) {
      if((device.vendorId == bootFilter.vendorId) && 
          (device.productId == bootFilter.productId)) {
          upgardeNormalDevice = false;
      } 
    }
  }
  else {
    upgradeState = UpgradeState.DeviceInvalid;
  }

  return valid;
}

async function DeviceOpen(temp) {
  if(mcuType == 1) {
    filters = [];
    var filter = {
      vendorId : temp.vendorId,
      productId : temp.productId
    }

    filters.push(filter);

    upgardeNormalDevice = true;
    currentDeviceIsNormal = true;
  }
  else {
    if((temp.vendorId == normalFilter.vendorId) &&
      (temp.productId == normalFilter.productId)) {
      device = temp;

      if(!device.opened) {
        await device.open();
      } 
    
      read_HID_Buffer();
      Device_Disconnect();

      upgardeNormalDevice = true;
      currentDeviceIsNormal = true;
    }
    else 
      currentDeviceIsNormal = false;
  }

  console.log("DeviceOpen",currentDeviceIsNormal,temp,normalFilter)
}

//读USB设备上传的数据
function read_HID_Buffer() {
  device.oninputreport = async (event) => {
    receivedData = new Uint8Array(event.data.buffer);
    receivedFlag = true;
  }
}

//设备主动断开，例如拔出设备
function Device_Disconnect() {
  navigator.hid.ondisconnect = (event) => {

  } 
}

function ArrayToBootModeReport(bytes) {
  const report = {
    cmdlength : bytes[0],
    feature : bytes[1],
    command : new Uint8Array(CommandLength - 2) 
  }

  for(let i = 0;i < CommandLength - 2;i++) {
    report.command[i] = bytes[i + 2];
  }

  return report;
}

function ByteToString(bytes) {
  let str = '';

  for (let i = 0; i < bytes.length; i++) {
    if (bytes[i]!== 0) {
        // 将非空字符的字节转换为对应的字符并添加到字符串中
        str += String.fromCharCode(bytes[i]);
    }
  }

  return str;
}

function ArrayToUpgradeFileHeader(bytes) {
  var headCRC = (bytes[3] << 24) | (bytes[2] << 16) | (bytes[1] << 8) | bytes[0];
  var headLength = (bytes[7] << 24) | (bytes[6] << 16) | (bytes[5] << 8) | bytes[4];
  var fwLength = (bytes[11] << 24) | (bytes[10] << 16) | (bytes[9] << 8) | bytes[8];
  var nextFileAddress = (bytes[15] << 24) | (bytes[14] << 16) | (bytes[13] << 8) | bytes[12];
  var version = (bytes[19] << 24) | (bytes[18] << 16) | (bytes[17] << 8) | bytes[16];
  var DeciveType = bytes[20];
  var Cid = bytes[21];
  var Mid = bytes[22];

  var fileId = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < fileId.length;i++) {
    fileId[i] = bytes[i + 23];
  }

  var icName = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < icName.length;i++) {
    icName[i] = bytes[i + 23 + MaxCmdLength];
  }

  var bootInputEndPoint = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < bootInputEndPoint.length;i++) {
    bootInputEndPoint[i] = bytes[i + 23 + MaxCmdLength * 2];
  }

  var bootOutputEndPoint = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < bootOutputEndPoint.length;i++) {
    bootOutputEndPoint[i] = bytes[i + 23 + MaxCmdLength * 3];
  }

  var normalInputEndPoint = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < normalInputEndPoint.length;i++) {
    normalInputEndPoint[i] = bytes[i + 23 + MaxCmdLength * 4];
  }

  var normalOutputEndPoint = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < normalOutputEndPoint.length;i++) {
    normalOutputEndPoint[i] = bytes[i + 23 + MaxCmdLength * 5];
  }

  var resetToUpdateModeCmd = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < resetToUpdateModeCmd.length;i++) {
    resetToUpdateModeCmd[i] = bytes[i + 23 + MaxCmdLength * 6];
  }

  var prepareDownLoadCmd = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < prepareDownLoadCmd.length;i++) {
    prepareDownLoadCmd[i] = bytes[i + 23 + MaxCmdLength * 7];
  }

  var dataDownLoadCmd = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < dataDownLoadCmd.length;i++) {
    dataDownLoadCmd[i] = bytes[i + 23 + MaxCmdLength * 8];
  }

  var senserName = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < senserName.length;i++) {
    senserName[i] = bytes[i + 23 + MaxCmdLength * 9];
  }

  var productName = new Uint8Array(MaxCmdLength);
  for(let i = 0;i < productName.length;i++) {
    productName[i] = bytes[i + 23 + MaxCmdLength * 10];
  }

  var obj = {
    headCRC : headCRC,//文件头crc
    headLength : headLength,//文件头长度
    fwLength : fwLength, //要下载的程序(firmware)长度,起始位置固定为BOOT_SIZE。
    nextFileAddress : nextFileAddress,//下一个文件的起始地址，用于多个芯片程序并在一个bin文档中，为0则表示没有

    version : version,
    DeciveType : DeciveType,
    Cid : Cid,
    Mid : Mid,
   
    fileId : fileId,//文件标识，固定为ComUpgradeFile    
    icName: icName,//ic的名字   
    bootInputEndPoint: bootInputEndPoint,//vid_3554&pid_f502&mi_01&col05   
    bootOutputEndPoint: bootOutputEndPoint,//vid_3554&pid_f502&mi_01&col05    
    normalInputEndPoint: normalInputEndPoint,//vid_3554&pid_f502&mi_01&col05    
    normalOutputEndPoint: normalOutputEndPoint,//vid_3554&pid_f502&mi_01&col05    
    resetToUpdateModeCmd: resetToUpdateModeCmd,//正常模式复位进入下载模式命令,第一个字节表示长度    
    prepareDownLoadCmd: prepareDownLoadCmd,//不同的ic，第一条预下载命令有可能不一样，所以单独存储，第一个字节表示长度    
    dataDownLoadCmd: dataDownLoadCmd,//数据下载包,第一个字节表示长度,第二个字节表示report id,其他字节无用     
    senserName: senserName,//鼠标所用的sensor   
    productName: productName,//产品名称

    string : {
      icName : ByteToString(icName),
      fileId : ByteToString(fileId),
      bootInputEndPoint : ByteToString(bootInputEndPoint),
      bootOutputEndPoint : ByteToString(bootOutputEndPoint),  
      normalInputEndPoint : ByteToString(normalInputEndPoint),
      normalOutputEndPoint : ByteToString(normalOutputEndPoint),
      senserName : ByteToString(senserName),
      productName : ByteToString(productName),
    }
  }

  return obj;
}

function GetHeaderCRC(UpgradeFileHeader,values) {
  var crc = 0;

  for(let i = 8;i < UpgradeFileHeader.headLength;i++) {
    crc += values[i];
  }

  return (0x55555555 - crc);
}

function IsValidHeader(fileHeader,upgradeData) {
  return (fileHeader.headCRC == GetHeaderCRC(fileHeader,upgradeData));
}

/*Check upgrade data is valid*/
function UsbUpgradeFile(upgradeData, _errorTimeout) {
  var header = ArrayToUpgradeFileHeader(upgradeData);

  if(IsValidHeader(header,upgradeData)) {
    errorTimeout = _errorTimeout;
    console.log("crc ok");
  }
  else {
    console.log("crc error");
    header = null;
  }

  return header;
}

/*Get upgrade device filter,include normal device and boot device*/
function GetUpgradeDeviceFilter() {
  var bootEndPoint = ByteToString(mainFileHeader.bootOutputEndPoint); 

  const boot = bootEndPoint.split('&');

  for(let i = 0;i < boot.length;i++) {
    var temp = '';
    if(boot[i].includes('vid')) {
      temp = boot[i].replace('vid_','');
      bootFilter.vendorId = UserConvert.String_To_Hex(temp)
    }
    else if(boot[i].includes('pid')) {
      temp = boot[i].replace('pid_','');
      bootFilter.productId = UserConvert.String_To_Hex(temp)
    }
  }

  var normalEndPoint = ByteToString(mainFileHeader.normalOutputEndPoint); 

  const normal = normalEndPoint.split('&');

  for(let i = 0;i < normal.length;i++) {
    var temp = '';
    if(normal[i].includes('vid')) {
      temp = normal[i].replace('vid_','');
      normalFilter.vendorId = UserConvert.String_To_Hex(temp)
    }
    else if(normal[i].includes('pid')) {
      temp = normal[i].replace('pid_','');
      normalFilter.productId = UserConvert.String_To_Hex(temp)
    }
  }
}

function UpgradeHandleInit(_upgradeData, _errorTimeout, _mcuType) {
  mcuType = _mcuType;
  console.log("UpgradeHandleInit",mcuType);
  if(mcuType == 1) {
    errorTimeout = _errorTimeout;
    upgradeDataCount = _upgradeData.length;
    Crc32();
    upgradeDataCrc = GetCRC(_upgradeData);
    CreateUpgradePacket(_upgradeData);

    return true;
  }
  mainFileHeader = UsbUpgradeFile(_upgradeData,_errorTimeout);

  if(mainFileHeader != null) {
    upgradeNext = false;

    hasNextDevice = mainFileHeader.nextFileAddress !== 0;
    if(hasNextDevice) {
      mainUpgradeData = new Uint8Array(mainFileHeader.nextFileAddress);

      slaveUpgradeData = new Uint8Array(_upgradeData.length - mainFileHeader.nextFileAddress);
      for(let i = 0;i < slaveUpgradeData.length;i++) {
        slaveUpgradeData[i] = _upgradeData[mainFileHeader.nextFileAddress + i];
      }

      slaveFileHeader = UsbUpgradeFile(slaveUpgradeData,_errorTimeout);

      if(slaveFileHeader == null)
        return false;
    }
    else {
      mainUpgradeData = new Uint8Array(_upgradeData.length);   
    }

    for(let i = 0;i < mainUpgradeData.length;i++) {
      mainUpgradeData[i] = _upgradeData[i];
    }

    console.log('UpgradeHandleInit',mainFileHeader,slaveFileHeader);

    GetUpgradeDeviceFilter();
  
    filters = [];
    filters.push(normalFilter);
    filters.push(bootFilter);
  
    reportIds = [];
    reportIds.push(normalReportId);
    reportIds.push(bootReportId);
  
    normalReportId = mainFileHeader.resetToUpdateModeCmd[2];
    bootReportId = mainFileHeader.prepareDownLoadCmd[2];

    return true;
  }
  else
    return false;
}

async function UpgradeStart() {
  var result = false;

  if(mcuType == 1) {
    if(await Request_Device()) {
      upgradeState.state = UpgradeState.Upgrading;
      if(await isDfuBusy()) {
        if(await DfuPrepareDownload()) {
          if(await isDfuReady()) {
            if(await NRF54DownLoadFile()) {
              if(await ResetDevice()) {
                upgradeState.state = UpgradeState.Success;
                result = true;
              }
            }
          }
        }
      }
    }
  }
  else {
  if(hasNextDevice) {
      if(currentDeviceIsNormal == false) {
        if(await Request_Device(filters,reportIds) == false) {
          return result;
        }
      }

      upgradeState.state = UpgradeState.Upgrading;

      if(upgardeNormalDevice) {
        CreateSlaveUpgradePacket();

        if(await ResetToBootMode()) {
          if(await DownLoadFile()) {
            CreateMainUpgradePacket();

            result = await ResetToBootMode(); 
            upgardeNormalDevice = false;
          }
        }       
      }
      else {
        CreateMainUpgradePacket();
        if(await DownLoadFile()) {
          CreateSlaveUpgradePacket();                    

          upgardeNormalDevice = true;
        }
      }  
    }
    else {
      CreateMainUpgradePacket();
      if(currentDeviceIsNormal == false) {
        if(await Request_Device(filters,reportIds) == false) {
          return result;
        }
        else {
          upgradeState.state = UpgradeState.Standby;
        }
      }

      if(upgardeNormalDevice) {
        if(await WaitBootMode()) {
          upgradeState.state = UpgradeState.Upgrading;
          result = await DownLoadFile();
        }
      }
      else {
        if(upgradeState.state == UpgradeState.UserCancel) {
          if(await Request_Device(filters,reportIds)) {//用户取消后需要再次弹窗选择buoot设备
            upgradeState.state = UpgradeState.Upgrading;
            result = await DownLoadFile();
          }
        }
        else {
          upgradeState.state = UpgradeState.Upgrading;
          result = await DownLoadFile();
        }
      } 
    }
  }
 

  return result;
}

async function UpgradeNextDevice() {
  var result = false;
  filters = [];
  filters.push(bootFilter);

  reportIds = [];
  reportIds.push(bootReportId);

  if(upgardeNormalDevice) {
    filters.push(normalFilter);

    reportIds.push(normalReportId);
  }
  else {
    filters.push(bootFilter);

    reportIds.push(bootReportId);
  }
  currentPacketCount = 0;
  upgradeNext = true;
  
  if(await Request_Device(filters,reportIds)){
    upgradeState.state = UpgradeState.Upgrading;
    if(upgardeNormalDevice) {
      await ResetToBootMode()
    }
    result = await DownLoadFile();
  } 

  return result;
}

function CreateMainUpgradePacket() {
  fileHeader = mainFileHeader;
  CreateUpgradePacket(mainUpgradeData);

  currentPacketCount = 0;
  totalPacketCount = writeQueue.length;
}

function CreateSlaveUpgradePacket() {
  fileHeader = slaveFileHeader;
  CreateUpgradePacket(slaveUpgradeData);

  currentPacketCount = 0;
  totalPacketCount = writeQueue.length;
}

function CreateUpgradePacket(upgradeData) {
  var downloadAddr = 0, dataCount = 0, maxSize = 32, binStartAddress = 0;
  let upgradeCmd = {
    isEnd : false,
    isValid : true,

    len : MaxCmdLength,
    buffer : new Uint8Array(MaxCmdLength),
  }

  writeQueue = [];

  if(mcuType == 0) {
    let report = ArrayToBootModeReport(fileHeader.prepareDownLoadCmd);

    upgradeCmd = Object.create(UsbUpgradeCommand);

    upgradeCmd.isEnd = false;
    upgradeCmd.isValid = true;
    upgradeCmd.len = report.cmdlength;

    upgradeCmd.buffer = new Uint8Array(report.cmdlength);

    for(let i = 0;i < report.cmdlength;i++) {
      upgradeCmd.buffer[i] = report.command[i];
    }

    writeQueue.push(upgradeCmd);

    report = ArrayToBootModeReport(fileHeader.dataDownLoadCmd);

    downloadAddr = ((report.command[5] << 24) + (report.command[6] << 16) + (report.command[7] << 8) + (report.command[8]));

    binStartAddress = BOOT_SIZE;

    dataCount = 0;

    while(dataCount < fileHeader.fwLength) {
      upgradeCmd = Object.create(UsbUpgradeCommand);
      upgradeCmd.buffer = new Uint8Array(MaxCmdLength);

      for(let i = 0;i < 32;i++) {
        upgradeCmd.buffer[i + 17] = 0xff;
      }

      upgradeCmd.buffer[0] = report.command[0];
      upgradeCmd.buffer[1] = Usb_Cmd.Cmd_DownLoadFile;

      if((dataCount + maxSize) >= fileHeader.fwLength) {
        upgradeCmd.buffer[2] = Usb_Packet.Usb_LastPacket;
        upgradeCmd.buffer[3] = fileHeader.fwLength - dataCount;
        upgradeCmd.isEnd = true;
      }
      else {
        upgradeCmd.buffer[2] = Usb_Packet.Usb_NextPacket;
        upgradeCmd.buffer[3] = maxSize;
        upgradeCmd.isEnd = false;
      }

      upgradeCmd.buffer[4] = 0;

      upgradeCmd.buffer[5] = (downloadAddr >> 24) & 0xff;
      upgradeCmd.buffer[6] = (downloadAddr >> 16) & 0xff;
      upgradeCmd.buffer[7] = (downloadAddr >> 8) & 0xff;
      upgradeCmd.buffer[8] = (downloadAddr ) & 0xff;

      for(let i = 0;i < upgradeCmd.buffer[3];i++) {
        upgradeCmd.buffer[i + 17] = upgradeData[binStartAddress + i];
      }

      downloadAddr += maxSize;
      dataCount += maxSize;
      binStartAddress += maxSize;

      upgradeCmd.isValid = true;

      upgradeCmd.len = report.cmdlength;
      writeQueue.push(upgradeCmd);
    }
  }
  else {
    var packet32KCount = Math.floor(upgradeDataCount / (32 * 1024));
    for(var i = 0;i < packet32KCount;i++) {
      CreatePerUpgradePacket(upgradeData, i, 32 * 1024);    
    }

    var lastCount = upgradeDataCount % (32 * 1024);
    if(lastCount) {
      CreatePerUpgradePacket(upgradeData, packet32KCount, lastCount);
    }
  }
}

function CalcDownloadPercent() {
  var percent = ((currentPacketCount * 100) / totalPacketCount);

  if(hasNextDevice) {
    percent /= 2;

    if(upgradeNext) {
      percent += 50;
    }
  }

  percent = Math.floor(percent);
  upgradeState.percent = percent;
}

function IsSameArray(buffer1,index1,buffer2,index2,len) {
  for (let i = 0; i < len; i++) {
    if (buffer1[i + index1] != buffer2[i + index2]) {
        return false;
    }
  }        

  return true;
}

async function ResetToBootMode() {
  var result = false;
  var findCount = 0, timeoutCount = 0, maxCount = 0;
  var osReadBuffer = new Uint8Array(MaxCmdLength), osSendBuffer = new Uint8Array(MaxCmdLength);

  let report = ArrayToBootModeReport(fileHeader.resetToUpdateModeCmd);
  SetUpgradeTimeout(VirtualPacketInterval);
  maxCount = (errorTimeout / (VirtualPacketInterval * 20));
  while(true) {
    if (isTimeOut) {
      SetUpgradeTimeout(VirtualPacketInterval);
      findCount++;
    }

    if(findCount > 20) {
      findCount = 0;

      if (++timeoutCount > maxCount) {
        break;
      }

      try {
        receivedFlag = false;
  
        for(let i = 0;i < osReadBuffer.length;i++) {
          osReadBuffer[i] = 0x00;
        }
  
        osSendBuffer = new Uint8Array(report.cmdlength - 1);
        for(let i = 0;i < osSendBuffer.length;i++) {
          osSendBuffer[i] = report.command[i + 1];
        }
  
        if(report.feature) {
          await device.sendFeatureReport(report.command[0], osSendBuffer);
        }
        else {
          await device.sendReport(report.command[0], osSendBuffer);
        }     
      }
      catch(e) {
        console.error(e);
        upgradeState.state = UpgradeState.DeviceError;
        result = false;
        break;
      }
    }

    if(receivedFlag) {
      for(let i = 0;i < receivedData.length;i++) {
        osReadBuffer[i] = receivedData[i];
      }

      if(IsSameArray(osSendBuffer,0,osReadBuffer,0,osSendBuffer.length - 1)) {
        currentPacketCount++;
        return true;
      }
    }

    await sleep(1);
  }

  return result;
}

async function WaitBootMode() {
  var result = false;

  if(await ResetToBootMode()) {
    var filters = [];
    filters.push(bootFilter);

    var reportIds = [];
    reportIds.push(bootReportId);

    if(await Request_Device(filters,reportIds)) {
      return true;
    }
  }

  return result;
}

function UpgradeTimeElapsed() {
  isTimeOut = true;
}

function SetUpgradeTimeout(count) {
  clearTimeout(upgradeTimerID);

  isTimeOut = false;

  upgradeTimerID = setInterval(UpgradeTimeElapsed,count);
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function DownLoadFile() {
  var isSuccess = false;

  var osReadBuffer = new Uint8Array(MaxCmdLength), osSendBuffer = new Uint8Array(MaxCmdLength);

  reSendIndex = -1;
  reSendCount = 0;

  var report = ArrayToBootModeReport(fileHeader.dataDownLoadCmd);

  SetUpgradeTimeout(errorTimeout);

  while(true) {
    if(writeQueue.length > 0 && writeQueue[0].isValid) {
      try {
        receivedFlag = false;

        for(let i = 0;i < osReadBuffer.length;i++) {
          osReadBuffer[i] = 0x00;
        }

        osSendBuffer = new Uint8Array(writeQueue[0].len - 1);
        for(let i = 0;i < osSendBuffer.length;i++) {
          osSendBuffer[i] = writeQueue[0].buffer[i + 1];
        }

        if(report.feature) {
          await device.sendFeatureReport(writeQueue[0].buffer[0], osSendBuffer);
        }
        else {
          await device.sendReport(writeQueue[0].buffer[0], osSendBuffer);
        }

        SetUpgradeTimeout(errorTimeout);

        writeQueue[0].isValid = false;
      }
      catch(e) {
        console.error(e);
        upgradeState.state = UpgradeState.DeviceError;
        isSuccess = false;
        break;
      }
    }

    if(receivedFlag) {
      receivedFlag = false;
      osReadBuffer = new Uint8Array(receivedData.length);

      for(let i = 0;i < receivedData.length;i++) {
        osReadBuffer[i] = receivedData[i];
      }

      if(UpgradeHandler(osReadBuffer)) {
        isSuccess = true;

        if ((hasNextDevice && upgradeNext) ||
            (hasNextDevice == false)) {
          console.log("All Upgrade Success");
        }
        else {
          upgradeState.state = UpgradeState.UpgradeNext;
          console.log("Upgrade One Device OK");
        }

        break;
      }
    }

    if(isTimeOut)
    {
      isSuccess = false;
      upgradeState.state = UpgradeState.TimeOutError;
      console.log("DownLoadFile timer out");
      break;
    }

    await sleep(1);
  }

  return isSuccess;
}

function UpgradeHandler(report) {
  var result = false;

  var buffer = new Uint8Array(report.length);

  for(let i = 0;i < buffer.length;i++) {
    buffer[i] = report[i];
  }

  if(report[0] == Usb_Cmd.Cmd_PrepareDownLoad) {//收到鼠标回传的擦写Flash指令

        
  }
  else if(report[0] === Usb_Cmd.Cmd_DeviceState) {
    if(report[1] !== 0xB5)
      return false;

    switch(report[2]) {
      case UpgradeStateParam.DeviceState_Earse_Backup:
      case UpgradeStateParam.DeviceState_Earse_Main:
        if(report[3] === 1) {
          if(writeQueue.length > 0) {
            currentPacketCount++;
            writeQueue.shift();
          }
        }
        else {

        }
        break;

      case UpgradeStateParam.DeviceState_CheckOK:
        break;

      case UpgradeStateParam.DeviceState_Success:
        if(hasNextDevice && upgradeNext) {
          upgradeState.state = UpgradeState.Success;
        }
        else if(hasNextDevice == false) {
          upgradeState.state = UpgradeState.Success;
        }

        result = true;
        break;
    }
  }
  else if(report[0] == Usb_Cmd.Cmd_DownLoadFile) {
    if(IsSameArray(buffer, 0, writeQueue[0].buffer, 1, report.length)) {
      currentPacketCount++;

      writeQueue.shift();
    }
    else {
      writeQueue[0].isValid = true;

      if(reSendIndex !== writeQueue.length) {
        reSendCount = 0;
        reSendIndex = writeQueue.length;
      }
      else {
        reSendCount++;

        if(reSendCount > 8) {
          upgradeState.state = UpgradeState.RepeatCountMax;
          writeQueue[0].isValid = false;
        }
      }
    }

    CalcDownloadPercent();
  }
  else if(report[0] === Usb_Cmd.Cmd_DeviceError) {
    if(report[1] !== 0xA5) {
      return false;
    }
  }

  return result;
}

/* NRF54H20 Upgrade*/
var upgradeDataCount = 0;
var Table = new Uint32Array(256);
var Polynomial = 0xEDB88320; // 反向多项式
var upgradeDataCrc;

var ReportId = 0x0C;
var DFU_STATE = {
  DFU_STATE_INACTIVE : 0x00,
  DFU_STATE_ACTIVE : 0x01,
  DFU_STATE_STORING : 0x02,
  DFU_STATE_CLEANING : 0x03,
}

var ConfigStatus = {
  PENDING : 0,
  GET_MAX_MOD_ID : 1,
  GET_HWID : 2,
  GET_BOARD_NAME : 3,
  INDEX_PEERS : 4,
  GET_PEER : 5,
  SET : 6,
  FETCH : 7,
  SUCCESS : 8,
  TIMEOUT : 9,
  REJECT : 10,
  WRITE_FAIL : 11,
  DISCONNECTED : 12,
  GET_PEERS_CACHE : 13,
  FAULT : 99
}

function Crc32() {
  for (let i = 0; i < Table.length; i++) {
    let crc = i;
    for (let j = 0; j < 8; j++) {
      crc = (crc >>> 1) ^ ((crc & 1) ? Polynomial : 0);
    }
    Table[i] = crc;
  }
}

function Compute(buffer,initialCrc) {
  let crc = (~initialCrc) >>> 0; // 初始值取反

  buffer.forEach(b => {
      crc = ((crc >>> 8) ^ Table[(crc & 0xFF) ^ b]) >>> 0;
  })

  return ((~crc) >>> 0); // 结果取反
}

function GetCRC(buffer) {
    var pageSize = 512;//一次只计算512字节

    let crc = 1;//初始值为1

    var pageArray = new Uint8Array(pageSize);

    var count = Math.floor(buffer.length / pageSize);
    for (let i = 0; i < count; i++ ) {
      for(let j = 0;j < pageSize;j++) {
        pageArray[j] = buffer[pageSize * i + j];
      }

      crc = Compute(pageArray, crc);
    }

    //最后一页
    var lastCount = buffer.length % pageSize;

    if (lastCount > 0) {
      var lastPageArray = new Uint8Array(lastCount);

      for(let j = 0;j < lastCount;j++) {
        lastPageArray[j] = buffer[buffer.length - lastCount + j];
      }

      crc = Compute(lastPageArray, crc);
    }

    return crc;
}

function CreatePerUpgradePacket(upgradeData, index, size) {
  var packetCount = Math.floor(size / 116);
  var packet = [];
  for(var i = 0;i < packetCount;i++) {
    packet = new Uint8Array(116);

    for(var j = 0;j < 116;j++) {
      packet[j] = upgradeData[index * (32 * 1024) + i * 116 + j];
    }

    writeQueue.push(packet);
  }

  var lastCount = size % 116;
  if(lastCount > 0) {
    packet = new Uint8Array(lastCount);

    for(var j = 0;j < lastCount;j++) {
      packet[j] = upgradeData[index * (32 * 1024) + (size - lastCount) + j];
    }

    writeQueue.push(packet);
  }
}

async function BufferSendReceive(dfuState, configStatus,packet) {
  var buffer = new Uint8Array(120);
  buffer[0] = 0;
  buffer[1] = dfuState;
  buffer[2] = configStatus;
  if(packet != null) {
    buffer[3] = packet.length;

    for(var i = 0;i < packet.length;i++) {
      buffer[4 + i] = packet[i];
    }
  }

  await device.sendFeatureReport(ReportId, buffer);
  await sleep(2);
  const receive = await device.receiveFeatureReport(ReportId);

  var receiveBuffer = new Uint8Array(receive.buffer);

  var recevieLen = receiveBuffer[4];
  var receivePacket = new Uint8Array(recevieLen);

  for(var i = 0;i < recevieLen;i++) {
    receivePacket[i] = receiveBuffer[5 + i];
  }

  return receivePacket;  
}

function MaxRetryCount(count) {
  if(count > 10) {
    upgradeState.state = UpgradeState.RepeatCountMax;
    return true;
  }
  return false;
}

async function isDfuBusy() {
  var retryCount = 0;
  while(true) {
    var buffer = await BufferSendReceive(DFU_STATE.DFU_STATE_CLEANING,ConfigStatus.FETCH,null);

    if(buffer.length == 0x0F) {
      if(buffer[0] == DFU_STATE.DFU_STATE_INACTIVE) {
        return true;
      }
    }

    await sleep(20);
    retryCount++;
    if(MaxRetryCount(retryCount)) {
      return false;
    }
  }
}

async function DfuPrepareDownload() {
  var retryCount = 0;
  while(true) {
    var packet = new Uint8Array(0x0C);
    packet[0] = (upgradeDataCount & 0xFF);
    packet[1] = ((upgradeDataCount >> 8) & 0xFF);
    packet[2] = ((upgradeDataCount >> 16) & 0xFF);
    packet[3] = ((upgradeDataCount >> 24) & 0xFF);
    packet[4] = (upgradeDataCrc & 0xFF);
    packet[5] = ((upgradeDataCrc >> 8) & 0xFF);
    packet[6] = ((upgradeDataCrc >> 16) & 0xFF);
    packet[7] = ((upgradeDataCrc >> 24) & 0xFF);

    var buffer = await BufferSendReceive(DFU_STATE.DFU_STATE_ACTIVE,ConfigStatus.SET,packet);
    if(buffer.length == 0x00) {
      return true;    
    }

    await sleep(20);
    retryCount++;
    if(MaxRetryCount(retryCount)) {
      return false;
    }  
  }
}

function checkPacketParam(buffer) {
  if(buffer.length == 0x0F) {
    if(buffer[0] == DFU_STATE.DFU_STATE_ACTIVE) {
      var len = ((buffer[1] + (buffer[2] << 8) + (buffer[3] << 16) + (buffer[4] << 24)) >>> 0);
      var crc = ((buffer[5] + (buffer[6] << 8) + (buffer[7] << 16) + (buffer[8] << 24)) >>> 0);
      var _offset = ((buffer[9] + (buffer[10] << 8) + (buffer[11] << 16) + (buffer[12] << 24)) >>> 0);

      if((len == upgradeDataCount) && (crc == upgradeDataCrc)) {
        return true;
      }
      else {
        return false;
      } 
    }  
  }

  return false;
}

async function isDfuReady() {
  var retryCount = 0;
  while(true) {
    var buffer = await BufferSendReceive(DFU_STATE.DFU_STATE_CLEANING,ConfigStatus.FETCH,null);

    if(checkPacketParam(buffer)) {
      return true;
    }

    await sleep(20);
    retryCount++;
    if(MaxRetryCount(retryCount)) {
      return false;
    }
    else {
      await DfuPrepareDownload();
    }   
  }
}


async function Wait32KFlashComplete() {
  var retryCount = 0;
  while(true) {
    var buffer = await BufferSendReceive(DFU_STATE.DFU_STATE_CLEANING,ConfigStatus.FETCH,null);
    if(checkPacketParam(buffer)) {
      return true;
    }
    
    await sleep(300);
    retryCount++;
    if(MaxRetryCount(retryCount)) {
      return false;
    }
  }
}

async function DownLoadFile_Packet(index) {
  var retryCount = 0;
  while(true) {
    SetUpgradeTimeout(errorTimeout);
    var buffer = await BufferSendReceive(DFU_STATE.DFU_STATE_STORING,ConfigStatus.SET,writeQueue[index]);

    if(buffer.length == 0x0) {
      currentPacketCount = index;
      CalcDownloadPercent();
      return true;     
    }

    await sleep(20);
    retryCount++;
    if(MaxRetryCount(retryCount)) {
      return false;
    }
  }
}

async function NRF54DownLoadFile() {
  SetUpgradeTimeout(errorTimeout);
  currentPacketCount = 0;
  totalPacketCount = writeQueue.length;
  var packageCount = writeQueue.length;
  var packet32KCount = Math.floor((32 * 1024 / 116));
  for(var i = 0;i < packageCount;i++) {
    if(await DownLoadFile_Packet(i)) {
      if((i % (packet32KCount + 1) == packet32KCount)) {
        if(await Wait32KFlashComplete() == false) {
          return false;
        }
      }
    }
    else {
      return false;
    }

    if(isTimeOut)
    {
      upgradeState.state = UpgradeState.TimeOutError;
      console.log("DownLoadFile timer out");
      return false;
    }
  }

  if(await isDfuBusy() == false) {
    return false;
  }

  return true;
}

async function ResetDevice() {
  var retryCount = 0;
  while(true) {
    var buffer = await BufferSendReceive(0x04,ConfigStatus.FETCH,null);

    if(buffer.length == 0x01) {
      if(buffer[0] == DFU_STATE.DFU_STATE_ACTIVE) {
        currentPacketCount = totalPacketCount;
        CalcDownloadPercent();
        return true;
      }
    }

    await sleep(300);
    retryCount++;
    if(MaxRetryCount(retryCount)) {
      return false;
    }
  }
}

export default {
/* Upgarde handle init
param1: upgrade data
param2: upgrade timeout(1000=>1 second) 
return:false upgrade data is invalid
       true upgrade data is valid
*/
  UpgradeHandleInit,
/* Upgrade start
It's will pop connection windows when you use this function
return:false no vaild device
       true "hasNextDevice === false"all device upgrade success
            "hasNextDevice === true"first device upgrade success
*/
  UpgradeStart,
/* Upgrade Next Device
If "hasNextDevice" is true,you need use this function after UpgradeStart is true
It's will pop connection windows when you use this function
return:false no vaild device
       true all device upgrade success
*/
  UpgradeNextDevice,

  DeviceOpen,
/*
var upgradeState ={
  state:'Standby',
  percent:0
};
state:upgrade state 
      //>0x80 means upgrade fail,developer must log the upgarde info,such as upgrade data,or upgrade url
percent: upgrade percent
*/
  upgradeState,
  UpgradeState,
/*
hasNextDevice 
true:need upgrade next device(UpgradeNextDevice)
*/
  hasNextDevice,

  currentDeviceIsNormal,
}